"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
const CallToAction = _ref => {
  let {
    children,
    className,
    element = 'button',
    fullWidth = false,
    inverted = false,
    disabled = false,
    inferior = false,
    ...restProps
  } = _ref;
  const props = {
    className: (0, _classnames.default)(_indexModule.default.root, className, {
      [_indexModule.default.fullWidth]: fullWidth,
      [_indexModule.default.inverted]: inverted,
      [_indexModule.default.disabled]: disabled,
      [_indexModule.default.inferior]: inferior
    }),
    disabled,
    ...restProps
  };
  return /*#__PURE__*/_react.default.createElement(element, props, children);
};
var _default = exports.default = CallToAction;